import { useEffect, useState } from "react";
import { adminGetRoster, adminAddRoster, adminDeleteRoster } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";

export default function AdminRoster() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ group: "", name: "" });
  const load = () => adminGetRoster().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.group.trim() || !form.name.trim()) return;
    await adminAddRoster({ group: form.group, name: form.name, order: 99 });
    setForm({ group: "", name: "" }); load();
  };
  const remove = async (g, n) => { await adminDeleteRoster(g, n); load(); };

  const groups = items.reduce((acc, r) => { (acc[r.group] = acc[r.group] || []).push(r); return acc; }, {});

  return (
    <div data-testid="admin-roster">
      <p className="cv-kicker">Logo roster</p>
      <h1 className="cv-display text-3xl mt-4">Named institutions.</h1>
      <form data-testid="admin-roster-add-form" onSubmit={add} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-2xl">
        <input data-testid="admin-roster-group" className="cv-input" placeholder="Group (e.g. Fortune 500)" value={form.group} onChange={(e) => setForm({ ...form, group: e.target.value })} />
        <input data-testid="admin-roster-name" className="cv-input" placeholder="Institution name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <button data-testid="admin-roster-add" className="cv-btn-primary inline-flex items-center gap-2 whitespace-nowrap"><Plus size={14} /> Add</button>
      </form>
      <div className="mt-8 space-y-6 max-w-2xl">
        {Object.entries(groups).map(([g, list]) => (
          <div key={g}>
            <p className="cv-kicker">{g}</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {list.map((r) => (
                <span key={r.name} className="inline-flex items-center gap-2 border border-[rgba(28,27,25,0.14)] rounded-full px-3 py-1.5">
                  <span className="cv-sans uppercase tracking-[0.1em] text-[0.68rem]">{r.name}</span>
                  <button data-testid="admin-roster-delete" className="text-[#A65A43]" onClick={() => remove(g, r.name)}><Trash2 size={12} /></button>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
